export default __webpack_public_path__ + "static/media/Frame.5e0d7244.png";